import React, { useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import FocusTrap from "focus-trap-react";

function ConfirmModal({ message, onConfirm, onCancel }) {
  const containerRef = useRef(null);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") onCancel?.();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [onCancel]);

  return (
    <Modal show onHide={onCancel} centered>
      <FocusTrap
        active
        focusTrapOptions={{
          initialFocus: () => containerRef.current?.querySelector(".btn-primary") || containerRef.current,
          allowOutsideClick: true,
          returnFocusOnDeactivate: true,
        }}
      >
        <div ref={containerRef}>
          <Modal.Header closeButton>
            <Modal.Title id="confirm-modal-title">Confirm</Modal.Title>
          </Modal.Header>
          <Modal.Body id="confirm-modal-body">{message}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" onClick={onConfirm}>
              Confirm
            </Button>
          </Modal.Footer>
        </div>
      </FocusTrap>
    </Modal>
  );
}

export default ConfirmModal;
